export default __webpack_public_path__ + "static/media/1515.57d6bbe8.png";